import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const IconWrapper = styled.span`
  margin: ${Spacing.S32};
  font-size: 40px;

  > svg {
    width: 40px;
    height: 40px;
  }
`

export const ButtonWrapper = styled.span`
  margin: ${Spacing.S12};
`
